<div class="label-container">
  <div class="label-content">
    <ng-content select="[left]"></ng-content>
  </div>

  <div
    class="label"
    [class.f-muted]="color() === 'gray'"
    [onyxTooltip]="label()"
    [onyxTooltipDisabled]="
      overflowHelper.hasNoOverflow.bind(overflowHelper, labelTextElement)
    "
    #labelTextElement
  >
    {{ label() | translate }}
  </div>
</div>

<div class="content {{ color() }} f-body-m f-medium">
  <ng-content select="[icon]"></ng-content>

  <ng-content></ng-content>
</div>
